import { render, staticRenderFns } from "./CreateArticleTitleField.vue?vue&type=template&id=408cec3f"
import script from "./CreateArticleTitleField.vue?vue&type=script&lang=js"
export * from "./CreateArticleTitleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports